import React, { useReducer, FC } from 'react';
import SummaryProvider, {
  useAppliedFilter,
  useFilterSummary,
  useFilterChanges,
} from './SummaryProvider';
import ActionsProvider, {
  reducer,
  useLegFilterActions,
  useFilterActions,
} from './ActionsProvider';
import PredicateProvider, { usePredicate } from './PredicateProvider';
import StateProvider, {
  useLegFilterState,
  useAvailableConnectionThresholds,
} from './StateProvider';
import {
  ConnectionThresholdFilterProviderProps,
  FilterTransportType,
} from './types';
import { useTransportTypeProduct } from '../../TransportTypeFilter/Provider';

const ConnectionThresholdFilterProvider: FC<
  ConnectionThresholdFilterProviderProps
> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, null);
  const { product } = useTransportTypeProduct();

  return (
    <StateProvider connectionThresholds={state}>
      <PredicateProvider transportType={product as FilterTransportType}>
        <ActionsProvider dispatch={dispatch}>
          <SummaryProvider>{children}</SummaryProvider>
        </ActionsProvider>
      </PredicateProvider>
    </StateProvider>
  );
};

export default ConnectionThresholdFilterProvider;

export {
  useLegFilterState as useSelectedConnectionThreshold,
  useAvailableConnectionThresholds,
  useLegFilterActions as useConnectionThresholdFilterActions,
  usePredicate as useConnectionThresholdFilterPredicate,
  useAppliedFilter as useAppliedConnectionThresholdFilter,
  useFilterSummary as useConnectionThresholdFilterSummary,
  useFilterActions as useConnectionThresholdsFilterActions,
  useFilterChanges as useConnectionThresholdFilterChanges,
};
